import {useBookList}  from "@/modules/home/booklist";
import {useBookInfo} from "@/modules/reader/book/bookinfo";
import {useBookmark} from "@/modules/reader/bookmark/bookmark";
import {usePaging} from "@/modules/reader/book/paging";
import {usePageResize} from "@/modules/reader/book/pageResize";
import {usePlayBlockControl} from "@/modules/reader/karaoke/playBlockControl";
import {useKaraokeControl} from "@/modules/reader/karaoke/karaokeControl";
import {useMuteRoleControl} from "@/modules/reader/karaoke/muteRoleControl";
import {usePpanel}  from "@/modules/reader/ppanel/ppanel";
import {useTool} from "@/modules/reader/tools/tools";
import {useInlineExercise} from "@/modules/reader/inlineExercise/inlineExercise";
import {useDataLoader} from "@/modules/reader/book/dataLoader";
import {useParser} from "@/modules/reader/annotations/parser";

/**
 * Clear the data used in Home Component
 */
const clearHomeData = ()=>{

    useBookList().reset();
}

/**
 * Clear the data used in Reader Component
 */
const clearReaderData =() => {

    useBookInfo().reset();
    usePaging().reset();
    usePpanel().reset();
    usePageResize().reset();
    useTool().reset();
    useBookmark().reset();
    useInlineExercise().reset();
    useKaraokeControl().reset();
    usePlayBlockControl().reset();
    useMuteRoleControl().reset();
    useDataLoader().reset();
    useParser().reset();

}

export { clearHomeData, clearReaderData }
